export const GET_FACTORS = "GET_FACTORS";
export const GET_FACTOR_BY_ID = "GET_FACTOR_BY_ID";
export const UPDATE_FACTOR = "UPDATE_FACTOR";
export const DELETE_FACTOR = "DELETE_FACTOR";
export const CREATE_FACTOR = "CREATE_FACTOR";
